import { Tag } from "antd";
import { setDoc } from "firebase/firestore";
import { Actions } from "../../components/buttons/Actions";
import { showMessage } from "../../components/message/GenericMessage";
import { actionsColumn, createdColumn } from "../../constants/objects";
import { sPending, sResolved } from "../../constants/strings";
import { PENDING, STATUS_RESOLVED } from "../../constants/webapp";
import { useAppContext } from "../../context/useAppContext";
import { TicketDetails } from "../../pages/tickets/TicketDetails";
import { dateTimeFormat } from "../../utils/formatter";
import { DescWrapper } from "../useProducts";

export function getTicketStatus(key) {
  let color, status;
  switch (key) {
    case STATUS_RESOLVED:
      status = sResolved;
      color = "green";
      break;

    default:
      status = sPending;
      break;
  }
  return { color, status };
}

export function ActionsUpdate(item, data) {
  if (item.docRef && item.status !== data.status) {
    setDoc(item.docRef, data, { merge: true }).then(() =>
      showMessage("Updated Successfully")
    );
  }
}

export const useTickets = () => {
  const { contextData } = useAppContext();

  const tableData = (data) => [
    ...data.map((item) => {
      const { id, topic, email, timestamp, status, description } = item || {};
      const row = {
        ticket_number: `#${id}`,
        email: email,
        topic: (
          <div>
            <p>{topic}</p>
            <DescWrapper className="font11 thin lightColor ellipsis">
              {description}
            </DescWrapper>
          </div>
        ),
        timestamp: dateTimeFormat(timestamp),
        status: (
          <Tag style={{ margin: 0 }} color={getTicketStatus(status).color}>
            {getTicketStatus(status).status}
          </Tag>
        ),
        actions: (
          <Actions
            actions={[
              {
                action:
                  status === PENDING ? "Mark as Resolved" : "Mark as Pending",
                click: () =>
                  ActionsUpdate(item, {
                    status: status === PENDING ? STATUS_RESOLVED : PENDING,
                  }),
              },
            ]}
          />
        ),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: <TicketDetails data={item} />,
            title: "Ticket Details",
          }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "topic", title: "Topic", align: "left" },
    { id: "ticket_number", title: "Ticket Number" },
    { id: "email", title: "Email" },
    createdColumn,
    { id: "status", title: "Status" },
    actionsColumn,
  ];

  return { tableColumns, tableData };
};
